exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".tab_container div{padding:5px 20px}.tab_container div label{font-size:14px;display:inline-flex}.tab_container input[type=checkbox]{width:16px;height:16px;vertical-align:middle;margin-top:0;background:#fff;border:1px solid #999;border-radius:3px;min-height:16px;min-width:16px;margin-top:2px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/globalUserSet/styles.css
// module id = 631
// module chunks = 2